import React from 'react';

const Analytics: React.FC = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-gray-900">Analytics</h1>
        <p className="mt-2 text-gray-600">Business insights and performance metrics</p>
      </div>
      <div className="card">
        <p className="text-gray-500">Analytics dashboard coming soon...</p>
      </div>
    </div>
  );
};

export default Analytics; 